import React, { useState, useContext, useEffect, useRef } from "react";
import { AppContext } from "./context/appContext";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { apiUrl } from "../../config/config";
import { toast } from "react-toastify";

const getCustomContent = () => {
  const activities = {
    shoulderRelease: {
      title: "Side Stretch Sequence",
      description:
        "Stand with feet shoulder-width apart, raise your arms above your head, interlace your fingers, and gently stretch to the left and right. Hold each side for 10 seconds and repeat 5 times.",
      duration: "2 Minutes",
      category: "Stretching",
    },
    meditation: {
      title: "Mindful Breathing Meditation",
      description:
        "Sit comfortably with your back straight. Close your eyes, focus on your breath, and notice the sensation of air entering and leaving your nostrils. When your mind wanders, gently return focus to your breath.",
      duration: "5 Minutes",
      category: "Meditation",
    },
    cardio: {
      title: "Energy-Boosting Jumping Jacks",
      description:
        "Stand with feet together and arms at your sides. Jump while spreading your legs and raising your arms above your head, then jump back to the starting position. Repeat for 10 repetitions.",
      duration: "1 minute",
      category: "Cardio",
    },
    movement: {
      title: "Movement Break Walk",
      description:
        "Take 5 complete rounds walking through your house or office. Focus on your posture, engage your core, and breathe deeply. Use this time to reset your mind and reduce sitting time.",
      duration: "3-5 minute",
      category: "Movement",
    },
    breathwork: {
      title: "4-4-6 Breathing Technique",
      description:
        "Sit or stand comfortably. Inhale through your nose for 4 seconds, hold your breath for 4 seconds, then exhale slowly through your mouth for 6 seconds. Repeat for 5 rounds to reduce stress.",
      duration: "2 minute",
      category: "Breathwork",
    },
    strength: {
      title: "Desk Chair Squats",
      description:
        "Stand in front of your chair with feet hip-width apart. Lower yourself until you barely touch the chair, then stand back up. Keep your weight in your heels and chest lifted. Repeat 10 times.",
      duration: "2 minute",
      category: "Strength",
    },
    stretching: {
      title: "Wrist and Finger Stretch",
      description:
        "Extend your right arm with palm facing up. Use your left hand to gently pull fingers back toward your body. Hold for 10 seconds, then repeat with fingers pointing down. Switch hands and repeat.",
      duration: "1 minute",
      category: "Stretching",
    },
    mindfulness: {
      title: "Gratitude Reflection",
      description:
        "Close your eyes and bring to mind three things you're grateful for today. Focus on each one for 20 seconds, noticing any positive feelings that arise. This practice shifts your mindset toward positivity.",
      duration: "2 minute",
      category: "Mindfulness",
    },
    shoulderstretching: {
      title: "Shoulder Tension Release",
      description:
        "Roll your shoulders forward 5 times, then backward 5 times. Next, lift your shoulders to your ears, hold for 3 seconds, then drop them completely. Repeat 3 times to release upper body tension.",
      duration: "1 minute",
      category: "Stretching",
    },
    bodystretching: {
      title: "Full Body Wake-Up",
      description:
        "Stand tall and reach up as high as possible, rising onto your toes. Hold for 3 seconds, then bend forward, touching your toes (or as far as comfortable). Roll back up slowly. Repeat 5 times.",
      duration: "2 minute",
      category: "Stretching",
    },
    hydration: {
      title: "Hydration Reminder",
      description:
        "Pause to drink a full glass of water (8oz) slowly and mindfully. Notice the temperature and sensation as you drink, focusing entirely on this simple but essential wellness practice.",
      duration: "1 minute",
      category: "Hydration",
    },
    eyehealth: {
      title: "Eye Strain Relief",
      description:
        "Look away from your screen and focus on an object at least 20 feet away for 20 seconds. Then, close your eyes for 20 seconds. Finally, roll your eyes clockwise and counterclockwise 5 times each.",
      duration: "1 minute",
      category: "Eye Health",
    },
    standingstretching: {
      title: "Standing Calf Stretch",
      description:
        "Stand facing a wall with hands at eye level. Step one foot back, keeping it straight with heel on floor. Bend your front knee until you feel a stretch in the back leg's calf. Hold 15 seconds each side.",
      duration: "1 minute",
      category: "Stretching",
    },
    plankstrength: {
      title: "One-Minute Plank",
      description:
        "Start in push-up position with forearms on the floor. Keep your body in a straight line from head to heels, engaging your core. Hold this position for 30-60 seconds, breathing normally.",
      duration: "1 minute",
      category: "Strength",
    },
    relaxation: {
      title: "Body Scan Relaxation",
      description:
        "Starting from your toes and moving upward, focus your attention on each body part, noticing any tension and consciously releasing it as you breathe out. Move slowly through your entire body.",
      duration: "3 minute",
      category: "Relaxation",
    },
    standingquadstretching: {
      title: "Standing Quad Stretch",
      description:
        "Stand on one leg, grabbing your ankle with the same-side hand. Gently pull your heel toward your buttocks, keeping knees close together. Hold for 15 seconds and switch sides. Repeat twice.",
      duration: "1 minute",
      category: "Stretching",
    },
    posture: {
      title: "Mindful Posture Reset",
      description:
        "Sit or stand tall imagining a string pulling you up from the crown of your head. Roll shoulders back, relax arms, and engage core. Hold this proper alignment for 30 seconds, breathing deeply.",
      duration: "1 minute",
      category: "Posture",
    },
    pushupsstrength: {
      title: "Desk Push-ups",
      description:
        "Stand facing a desk with hands shoulder-width apart on the edge. Step back with feet together. Lower your chest toward the desk, then push back up. Keep your body straight and repeat 10 times.",
      duration: "1 minute",
      category: "Strength",
    },
    nostrilbreathwork: {
      title: "Alternate Nostril Breathing",
      description:
        "Use your right thumb to close right nostril. Inhale through left nostril, then close it with ring finger. Release thumb and exhale through right nostril. Continue alternating for 5 complete cycles.",
      duration: "2 minute",
      category: "Breathwork",
    },
    foldstretching: {
      title: "Forward Fold Refresh",
      description:
        "Stand with feet hip-width apart. Bend forward from the hips, letting arms and head hang loosely. Slightly bend knees if needed. Hold for 30 seconds, feeling the stretch along your back body.",
      duration: "1 minute",
      category: "Stretching",
    },
  };

  const keys = Object.keys(activities);
  const randomKey = keys[Math.floor(Math.random() * keys.length)];
  return activities[randomKey];
};

const Quiz = () => {
  const [searchParams] = useSearchParams();
  const cid = searchParams.get("cid");
  const { answers, setAnswers } = useContext(AppContext);
  const [currentQuestionId, setCurrentQuestionId] = useState("supplement");
  const [showSummary, setShowSummary] = useState(false);
  const navigate = useNavigate();
  const [streak, setStreak] = useState(0);
  const [reminder, setReminder] = useState(null);
  const [customerId, setCustomerId] = useState("");
  const [name, setName] = useState("");
  const [quizData, setQuizData] = useState("");
  const [isCompleteWithinTime, setIsCompleteWithinTime] = useState(false);
  const [history, setHistory] = useState([]);
  const [isFirstQuestion, setIsFirstQuestion] = useState(true);
  const [completedActivityTitle, setCompletedActivityTitle] = useState("");

  const completedActivityTitleRef = useRef();

  useEffect(() => {
    if (completedActivityTitle) {
      setCompletedActivityTitle("");
      completedActivityTitleRef.current = completedActivityTitle;
    }
  }, [completedActivityTitle]);

  const [customActivity, setCustomActivity] = useState(getCustomContent());

  useEffect(() => {
    setCustomActivity(getCustomContent());
  }, []);

  const TOKEN = cid;

  const submitQuizResults = async (currentAnswers) => {
    const quizData = {
      token: TOKEN,
      result: {
        ...currentAnswers,
      },
    };

    try {
      const response = await axios.post(
        `${apiUrl}/api/v1/wellness/quiz/create`,
        quizData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data.success) {
        setCustomerId(response?.data?.quizupdate?.customerId);
        setQuizData(response?.data?.quizupdate);
        setName(response?.data?.quizupdate?.name || "User");
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      toast.dismiss();
      toast.error(error?.response?.data?.message);
      console.error(
        "Error submitting quiz results:",
        error.response?.data || error.message
      );
    }
  };
  const checkMilestone = () => {
    // console.log("Milestone checked for streak:", streak);
  };
  const setCustomReminder = () => {
    // console.log("Custom reminder set");
  };
  const reorderSupplement = () => {
    // console.log("Reordering supplement...");
  };
  const trackProgress = () => {
    // console.log("Tracking progress...");
  };
  const showAction = (message) => {
    // console.log("Action:", message);
  };

  useEffect(() => {
    submitQuizResults();
  }, []);

  useEffect(() => {
    if (quizData && quizData.date && quizData.complete) {
      const yesterday8PM = new Date();
      yesterday8PM.setDate(yesterday8PM.getDate() - 1);
      yesterday8PM.setHours(20, 0, 0, 0);
      const today8PM = new Date();
      today8PM.setHours(20, 0, 0, 0);
      const quizDate = new Date(quizData.date);
      const isWithinTimeRange =
        quizDate >= yesterday8PM &&
        quizDate <= today8PM &&
        quizData.complete === true;

      setIsCompleteWithinTime(isWithinTimeRange);
    }
  }, []);

  useEffect(() => {
    const savedAnswers = JSON.parse(localStorage.getItem("quizAnswers"));
    if (savedAnswers) {
      setAnswers(savedAnswers);
    }
  }, []);

  const handleSelect = async (questionKey, answer, activityTitle) => {
    if (isFirstQuestion) setIsFirstQuestion(false);

    const selectedOption = questions[questionKey]?.options.find(
      (option) => option.label === answer
    );

    if (selectedOption?.action) {
      selectedOption.action();
    }

    const updatedAnswers = { ...answers, [questionKey]: answer };

    const sendPayload =
      questionKey === "activity"
        ? {
            ...answers,
            [questionKey]: activityTitle,
          }
        : updatedAnswers;

    try {
      const response = await axios.post(
        `${apiUrl}/api/v1/wellness/quiz/create`,
        {
          token: TOKEN,
          result: { ...sendPayload },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response?.data.success) {
        setAnswers(updatedAnswers);
        localStorage.setItem("quizAnswers", JSON.stringify(updatedAnswers));
        setCustomerId(response?.data?.quizupdate?.customerId);
        setName(response?.data?.quizupdate?.name);
        if (selectedOption?.nextId) {
          setHistory((prev) => [...prev, currentQuestionId]);
          setTimeout(() => setCurrentQuestionId(selectedOption.nextId), 200);
        } else {
          setShowSummary(true);
        }
      } else {
        toast.error(response?.data?.message || "Failed to save quiz progress.");
      }
    } catch (error) {
      toast.dismiss();
      toast.error(error?.response?.data?.message || "An error occurred.");
      console.error(
        "Error submitting quiz results:",
        error.response?.data || error.message
      );
    }
  };

  const handlePrevious = () => {
    if (history.length > 0) {
      const lastQuestion = history.pop();
      setHistory([...history]);
      setCurrentQuestionId(lastQuestion);
    }
  };
  const restartQuiz = () => {
    setAnswers({});
    setCurrentQuestionId("supplement");
    setShowSummary(false);
    localStorage.removeItem("quizAnswers");
  };

  const handleGoToDashboard = () => {
    navigate(`/wellness-dashboard/${customerId}`);
  };

  const questions = {
    supplement: {
      text: "Did you take your THC supplement today?",
      options: [
        {
          label: "Yes",
          nextId: "feeling",
          action: () => {
            setStreak(streak + 1);
            checkMilestone();
          },
        },
        {
          label: "No",
          nextId: "missedReason",
          action: () => {
            setStreak(0);
            checkMilestone();
          },
        },
      ],
    },
    missedReason: {
      text: "What made you miss your supplement today?",
      options: [
        { label: "Forgot", nextId: "reminderSuggestion" },
        { label: "Ran out", nextId: "reorderPrompt" },
        { label: "Didn't feel like it", nextId: "motivationCheck" },
        { label: "Too busy", nextId: "routineCheck" },
      ],
    },
    reminderSuggestion: {
      text: "Would you like to set up a daily reminder?",
      options: [
        { label: "Yes, please", nextId: "reminderTime" },
        { label: "No, thanks", nextId: "feeling" },
      ],
    },
    reminderTime: {
      text: "When's the best time to remind you?",
      options: [
        { label: "Custom Time", nextId: "customReminderTime" },
        {
          label: "Morning (8 AM)",
          nextId: "feeling",
          action: () => setReminder("8:00 AM"),
        },
        {
          label: "Evening (8 PM)",
          nextId: "feeling",
          action: () => setReminder("8:00 PM"),
        },
      ],
    },
    customReminderTime: {
      text: "Enter your preferred reminder time:",
      options: [
        {
          label: "Confirm",
          nextId: "feeling",
          action: () => setCustomReminder(),
        },
      ],
    },
    reorderPrompt: {
      text: "Would you like to reorder now?",
      options: [
        {
          label: "Yes, reorder",
          nextId: "feeling",
          action: () => reorderSupplement(),
        },
        { label: "Later", nextId: "feeling" },
      ],
    },
    motivationCheck: {
      text: "What's making it difficult to stay motivated?",
      options: [
        { label: "Not seeing results", nextId: "resultsTip" },
        { label: "Uncertain about benefits", nextId: "showEducation" },
      ],
    },
    resultsTip: {
      text: "Results take time. Would you like to track progress?",
      options: [
        {
          label: "Start tracking",
          nextId: "feeling",
          action: () => trackProgress(),
        },
        { label: "Maybe later", nextId: "feeling" },
      ],
    },
    showEducation: {
      text: "Here's a quick guide to THC.",
      videoUrl: "https://www.youtube.com/watch?v=GJaJQ3sFnzs",
      options: [{ label: "Done!", nextId: "feeling" }],
    },
    feeling: {
      text: "How are you feeling today?",
      options: [
        { label: "Energetic", nextId: "activityPrompt" },
        { label: "Balanced", nextId: "activityPrompt" },
        { label: "Low", nextId: "lowEnergyReason" },
      ],
    },
    lowEnergyReason: {
      text: "What's making you feel low today?",
      options: [
        { label: "Mental stress", nextId: "mentalWellness" },
        { label: "Physical fatigue", nextId: "physicalWellness" },
        { label: "Poor sleep", nextId: "sleepCheck" },
      ],
    },
    mentalWellness: {
      text: "Try a quick mental wellness exercise:",
      options: [
        {
          label: "Deep breathing",
          nextId: "activityPrompt",
          action: () =>
            showAction("Breathe in for 4 seconds, hold for 4, exhale for 6."),
        },
        { label: "Skip for now", nextId: "activityPrompt" },
      ],
    },
    physicalWellness: {
      text: "Try a quick physical wellness exercise:",
      options: [
        { label: "10 desk stretches", nextId: "activityPrompt" },
        { label: "5-minute meditation", nextId: "activityPrompt" },
        { label: "15 jumping jacks", nextId: "activityPrompt" },
      ],
    },
    sleepCheck: {
      text: "What's keeping you up?",
      options: [
        { label: "Stress", nextId: "" },
        { label: "Anxiety", nextId: "" },
        { label: "Pain", nextId: "" },
        { label: "Other", nextId: "caffeineCheck" },
      ],
    },
    caffeineCheck: {
      text: "Any caffeine after 2 PM?",
      options: [
        { label: "Yes", nextId: "" },
        { label: "No", nextId: "" },
      ],
    },
    activityPrompt: {
      text: "Ready for today's wellness activity?",
      options: [
        { label: "Show me", nextId: "activity" },
        { label: "Skip today", nextId: null },
      ],
    },
    activity: {
      text: "Try this quick wellness boost:",
      customContent: customActivity,
      specialKey: "multiQuestion",
      options: [
        {
          label: "Done!",
          nextId: null,
        },
        { label: "Skip", nextId: null },
        {
          label: "Show me other available activities.",
          specialKey: "newQuestion",
          nextId: "activity",
          action: () => {},
        },
      ],
    },
  };

  const currentQuestion = questions[currentQuestionId];

  return (
    <div className="h-screen w-full bg-gray-100 flex flex-col overflow-y-auto">
      <header className="bg-[#2F412F] sticky top-0 z-50 h-24 flex items-center justify-between p-5">
        {/* <div className="text-white text-lg md:text-2xl font-bold">
          The HealthSpan Co.
        </div> */}
        <Link to="https://thehealthspanco.com/">
            <img
              src="/whiteLogo.webp"
              alt="The HealthSpan Co."
              className="h-10 md:h-12 object-contain"
            />
          </Link>
        <button
          onClick={() =>
            (window.location.href = "https://thehealthspanco.com/")
          }
          className="bg-white px-3 md:px-4 py-1 md:py-2 text-xs md:text-base rounded text-red-600"
        >
          Exit
        </button>
      </header>

      {isCompleteWithinTime ? (
        <div className="flex items-center justify-center h-full  bg-gray-100">
          <div className="bg-white shadow-sm rounded-2xl border border-[#2d3d23] p-6 max-w-lg text-center">
            <h1 className="text-3xl font-bold text-[#2d3d23] mb-4">
              You have completed the quiz!
            </h1>
            <p className="text-gray-600 mb-6">
              Now, go to the dashboard page to see your results.
            </p>
            <button
              onClick={handleGoToDashboard}
              className="bg-[#2d3d23] hover:bg-[#6d4137] text-white font-medium px-6 py-3 rounded-lg transition duration-300"
            >
              Go to Wellness Dashboard
            </button>
          </div>
        </div>
      ) : (
        <div className="flex flex-1 justify-center items-center p-4 md:p-6 flex-col">
          {isFirstQuestion && (
            <h1 className="text-xl lg:text-2xl xl:text-3xl font-bold text-center mb-3 flex flex-col justify-center">
              <span className="mb-1">Hi {name},</span>{" "}
              <span className="text-lg font-medium">
                Here is your daily checkin
              </span>
            </h1>
          )}
          <div className="w-full max-w-lg md:max-w-xl lg:max-w-2xl bg-white rounded-xl shadow-lg overflow-hidden min-h-[375px] md:min-h-auto flex flex-col">
            <div className="bg-[#2d3d23] text-white text-center p-4 font-bold text-lg">
              {showSummary ? "Summary" : " Daily Wellness Check"}
            </div>
            <div className="p-6 h-full flex items-center ">
              {showSummary ? (
                <div className="w-full">
                  <h2 className="text-lg font-semibold text-center mb-4">
                    Today's Summary
                  </h2>
                  <table className="w-full border border-collapse">
                    <tbody>
                      {Object.entries(answers).map(([key, value]) => (
                        <tr key={key} className="border">
                          <td className="p-2 border">{questions[key]?.text}</td>
                          <td className="p-2 border">
                            {value || "No response"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="flex justify-between mt-4">
                    <button
                      onClick={restartQuiz}
                      className="bg-[#2d3d23] hover:bg-[#6d4137] text-white px-4 py-2 rounded-md mr-4"
                    >
                      Restart
                    </button>
                    <button
                      onClick={handleGoToDashboard}
                      className="bg-[#2d3d23] hover:bg-[#6d4137] text-white px-4 py-2 rounded-md"
                    >
                      Go to Wellness Dashboard
                    </button>
                  </div>
                </div>
              ) : (
                <div className="flex flex-col w-full">
                  <div className="text-gray-600 text-sm flex justify-between mb-2">
                    <p>Wellness Streak</p>
                    <p>🏆 {streak} days</p>
                  </div>
                  <h2 className="text-lg font-semibold text-center mb-4">
                    {currentQuestion?.text}
                  </h2>
                  {currentQuestion?.customContent && (
                    <div className="bg-gray-100 rounded-md p-4 mb-4 shadow">
                      <h3 className="text-md font-bold mb-2">
                        {currentQuestion.customContent.title}
                      </h3>
                      <h5 className="text-sm mb-2">
                        {currentQuestion.customContent.description}
                      </h5>
                      <p className="text-sm text-gray-600 font-semibold">
                        {currentQuestion.customContent.duration}{" "}
                        <span className="mr-1">|</span>
                        {currentQuestion.customContent.category}
                      </p>
                    </div>
                  )}
                  <div className="flex flex-col gap-2">
                    {currentQuestion?.options.map((option, index) => (
                      <button
                        key={index}
                        onClick={() => {
                          if (currentQuestion?.specialKey === "multiQuestion") {
                            if (option?.specialKey === "newQuestion") {
                              const newActivity = getCustomContent();
                              setCustomActivity(newActivity);
                            } else {
                              handleSelect(
                                currentQuestionId,
                                option.label,
                                customActivity?.title
                              );
                            }
                          } else {
                            handleSelect(currentQuestionId, option.label);
                          }
                        }}
                        className="bg-[#2d3d23] hover:bg-[#6d4137] text-white px-4 py-2 rounded-md"
                      >
                        {option.label}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
          {!showSummary && (
            <div class="w-full max-w-lg md:max-w-xl lg:max-w-2xl mt-6 ">
              <div
                className={`px-6 cursor-pointer py-3 bg-gray-100 hover:bg-[#2F412F] hover:text-white rounded-lg font-semibold inline-block ${
                  history.length === 0 ? "opacity-50 cursor-not-allowed" : ""
                }`}
                onClick={handlePrevious}
              >
                <span class="border-b border-[#2F412F]">Previous</span>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Quiz;
